@let blok = layout();

@if (blok?.header) {
  <header class="fixed left-0 right-0 top-0 min-h-16 flex px-5 z-30 logo-dark"
          [lightMode]="blok!.light_mode"
          appNavScroll>
    <div
      class="mx-auto max-w-content-width flex justify-between items-center flex-1 gap-5">
        <s1-cms-component [blok]="blok!.header[0]" id="nav_logo_dark"/>
        <s1-cms-component [blok]="blok!.header[1]" id="nav_logo_white"/>
      <button (click)="openMenu()" #menuButton aria-label="Open Menu"
              class="ml-auto flex justify-center items-center w-12 h-12">
        <mat-icon fontIcon="menu"/>
      </button>
    </div>
  </header>
}

@if (blok?.nav_children) {
  <nav [nav_children]="blok!.nav_children"
       [nav_logo]="navLogo"
       app-navigation>
  </nav>
}

<main [class]="baseClass + '--main'"
      [ngStyle]="{'--height-header': 64 + 'px'}">
  <ng-content/>
</main>

<app-scroll-to-table/>

@if (blok?.footer) {
  <footer>
    @for (child of blok?.footer; track child['_uid']) {
      <s1-cms-component [blok]="child"/>
    }
  </footer>
}

